import { getMomentTz } from "@dexteel/mesf-core";
import { Typography } from "@mui/material";
import {
	formatDurationHuman,
	formatTimeRange,
} from "../../utils/calendarUtils";
import type { RunSection } from "../../utils/dayHourGrid";
import { carryNote } from "../CarryMarker";

const moment = getMomentTz();

export const sectionTooltip = (s: RunSection) => {
	const start = moment.utc(s.event.Start).toDate();
	const end = moment.utc(s.event.End).toDate();
	const note = carryNote(s.event);
	return (
		<>
			<Typography variant="caption" component="div" sx={{ fontWeight: 600 }}>
				{s.title}
			</Typography>
			<Typography variant="caption" component="div">
				{formatTimeRange(start, end)} · {formatDurationHuman(start, end)}
			</Typography>
			{note && (
				<Typography variant="caption" component="div">
					{note}
				</Typography>
			)}
			{s.detail && (
				<Typography variant="caption" component="div">
					{s.detail}
				</Typography>
			)}
		</>
	);
};
